import schedule_gen_2 from '@devices/settings/device_settings/schedule_gen_2.js';
import webhooks_gen_2 from '@devices/settings/device_settings/webhooks_gen_2.js';
import scripts_gen_2 from '@devices/settings/device_settings/scripts_gen_2.js';
import share from '@devices/settings/device_settings/share.js';
import timer_diffuser_gen_2 from '@devices/settings/device_settings/timer_diffuser_gen_2';
import networks_gen_2_plus from '@devices/settings/device_settings/networks_gen_2_plus';
import bluetooth_gen_2 from '@devices/settings/device_settings/bluetooth_gen_2.js';

const settings = {
	//This settings will be extracted after their final version
	title: 'settings',
	components: [
		{
			title: 'eco_mode',
			component: 'eco_mode_g2',
		},
		{
			title: 'device_mode',
			component: 'device_mode_g2_cury',
		},
		{
			title: 'boost',
			component: 'boost_time_diffuser_gen_2',
		},
		{
			title: 'vial_auto_switching',
			component: 'vial_auto_switching_g2_cury',
		},
		{
			title: 'led_indicators',
			component: 'led_indicators_g2_cury',
		},
		{
			title: 'device_name',
			component: 'device_name_g2',
		},
		// {
		// 	title: 'device_card_customization',
		// 	component: 'customize_device_content',
		// },
		{
			title: 'firmware_version',
			component: 'firmware_update',
		},
		{
			title: 'geo_location_and_time_zone',
			component: 'location_g2',
		},
		{
			title: 'device_reboot',
			component: 'device_reboot',
		},
		{
			title: 'factory_reset',
			component: 'factory_reset',
		},
		{
			title: 'device_information',
			component: 'device_information',
		},
	],
};

export default {
	name: 'Cury',
	friendly_name: 'Cury',
	family: 'diffuser',
	isPM: false,
	modes: {
		diffuser: {
			availableViews: ['basic'],
			channels: 1,
			notifications: ['offline', 'device_problem'],
			settings: [
				timer_diffuser_gen_2,
				schedule_gen_2,
				webhooks_gen_2,
				scripts_gen_2,
				networks_gen_2_plus,
				bluetooth_gen_2,
				{
					title: 'application_settings',
					components: [
						{
							title: 'device_card_customization',
							component: 'customize_device_content',
						},
						{
							title: 'pin_lock',
							component: 'pin_lock',
						},
						{
							title: 'exclude_event_log',
							component: 'exclude_event_log',
						},
					],
				},
				share,
				settings, //TODO: add modes which are Modes: Boost/Away/Home/Office. Check if possible what are the values for the modes.
			],
		},
	},
};
